export default function () {
  return {
    loading: false,
    groups: {},
    currentGroup: null,
    groupsMap: {},
  };
}
